import SelectedCustomer from '@/platform/common/components/SelectedCustomer/SelectedCustomer';
import useDebounce from '@/platform/hooks/useDebounce';
import { useFilters } from '@/platform/hooks/useFilters';
import {
    FilterBar,
    FilterBarDropdown,
    FilterBarInput,
    Header,
} from '@/platform/ui';
import { BuildingOfficeIcon, UserIcon } from '@heroicons/react/24/outline';
import { usePage } from '@inertiajs/react';
import { useEffect, useRef, useState } from 'react';
import Steps from './Steps';

const START_YEAR = 2020;
const CURRENT_YEAR = new Date().getFullYear();

const YEAR_OPTIONS = Array.from(
    { length: CURRENT_YEAR - START_YEAR + 1 },
    (_, i) => ({ id: CURRENT_YEAR - i, name: String(CURRENT_YEAR - i) })
);

const Navigation = ({ reload = [] }) => {
    const { auth, employees_count } = usePage().props;
    const { filters, updateFilters } = useFilters([
        'business_rules',
        'contract_checks',
        'savings',
        ...reload,
    ]);
    const [employmentMonths, setEmploymentMonths] = useState(
        filters?.months || ''
    );
    const debouncedEmploymentMonths = useDebounce(employmentMonths);
    const isMounted = useRef(false);

    useEffect(() => {
        if (!isMounted.current) {
            isMounted.current = true;
            return;
        }

        updateFilters('months', debouncedEmploymentMonths);
    }, [debouncedEmploymentMonths]);

    return (
        <>
            <SelectedCustomer />
            <div className='mb-4 flex flex-col justify-between gap-4 sm:flex-row'>
                <div>
                    <Header as='h2'>WW-AWf Premie Check</Header>
                    <ul className='flex flex-row items-center gap-4 text-sm text-gray-500'>
                        <li className='inline-flex items-center gap-2'>
                            <BuildingOfficeIcon className='size-4' />
                            {auth?.customer?.name}
                        </li>
                        <li className='inline-flex items-center gap-2'>
                            <UserIcon className='size-4' />
                            {employees_count || 0} medewerkers
                        </li>
                    </ul>
                </div>
                <div>
                    <FilterBar>
                        <FilterBarInput
                            type='number'
                            min={0}
                            suffix='Dienstverband mnd'
                            value={employmentMonths}
                            onChange={setEmploymentMonths}
                        />
                        <FilterBarDropdown
                            clearable
                            label={`Entiteit (${auth?.customer?.entities?.find(e => e.id == filters?.entity_id)?.name || 'Alle'})`}
                            options={auth.customer?.entities?.map(entity => ({
                                id: entity.id,
                                name: entity.name,
                            }))}
                            value={filters?.entity_id || ''}
                            onChange={value =>
                                updateFilters('entity_id', value)
                            }
                        />
                        <FilterBarDropdown
                            clearable
                            label={`Jaar (${filters?.year || 'Alle'})`}
                            options={YEAR_OPTIONS}
                            value={filters?.year || ''}
                            onChange={value => updateFilters('year', value)}
                        />
                    </FilterBar>
                </div>
            </div>

            <Steps />
        </>
    );
};

export default Navigation;
